export default __webpack_public_path__ + "static/media/mercy-heal.3c95609f.mp3";